import script from "./ActionsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ActionsDropdown.vue?vue&type=style&index=0&id=5c5863cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5863cb"]])

export default __exports__